<button mat-stroked-button [class]="'brd-button ' + color" (click)="clickAction($event)" [disabled]="disabled">
  <div class="button-content">
    <mat-icon *ngIf="iconName" [svgIcon]="iconName"></mat-icon>
    <span>
      {{ text }}
    </span>
  </div>
</button>
